import axios from "axios";

export default function OfferStatisService(offerId, status) {
  return axios({
    method: 'POST',
    url: process.env.REACT_APP_API_HOST + "/offer/" + offerId + "/status/" + status,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
